import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import ButtonStyles from '../button-styles'
import ApiContext from '../../utils/api-context'
import classes from '../pages/destinations/destinations.module.scss'
import Hero from '../hero'
import Wrapper from '../layout/grid/wrapper'
import { Container, Grid, Snackbar } from '@material-ui/core'
import globalStyles from '../../styles/global-styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import {
  calculateMarkup,
  formatAmountForDisplay,
} from '../../utils/stripe-helpers'
import Watermark from '../svg/watermark.svg'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import Newsletter from '../newsletter'
import DiscoveryGallery from '../gallery/discovery'
import { buildGallery } from '../../lib/helpers'
import { CurrencyContext } from '../../lib/context/CurrencyContext'
import { SettingsContext } from '../../lib/context/SettingsContext'
import moment from 'moment'
import { useCookies } from 'react-cookie'
import MapOverlay from '../popups/map'
import RetreatFeatures from './retreat-features'
import { UserContext } from '../../lib/context/UserContext'
import LoginPopup from '../popups/login'
import CreateAccountPopup from '../popups/create-account'
import Overlay from '../overlay'
import MessageOverlay from '../overlays/retreat-pre-order'
import { CartContext } from '../../lib/context/cart-context'
import RetreatRooms from './retreat-rooms'
import { SearchContext } from '../../lib/context/search-context'
import config from '../../config'
import MuiAlert from '@material-ui/lab/Alert'
import PreOrder from '../enquiry/retreats/pre-order'
import { useModal } from '../../lib/context/modal-context'
import TripDates from '../widgets/trip-dates'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons'
import Share from '../share'

const RetreatDetails = ({ slug, details }) => {
  const [openMap, setOpenMap] = useState(false)
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const { setModal, modal } = useModal()
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const buttonStyles = ButtonStyles({})
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const { currency } = useContext(CurrencyContext)
  const { settings } = useContext(SettingsContext)
  const [cookies, setCookie] = useCookies(['searchparams'])
  const [numGuests, setNumGuests] = useState(1)
  const [numRooms, setNumRooms] = useState(1)
  const [guestsPopup2, setGuestsPopup2] = useState(false)
  const [cheapest, setCheapest] = useState(0)
  const [baseRate, setBaseRate] = useState(0)
  const [mobile, setMobile] = useState(true)
  const [totalPrice, setTotalPrice] = useState(0)
  const [selectedRoom, setSelectedRoom] = useState([])
  const [hasSelected, setHasSelected] = useState(false)
  const { user } = useContext(UserContext)
  const { addProduct, cartItems, id, addId, updateProduct } = useContext(
    CartContext
  )
  const [enquiryPopup, setEnquiryPopup] = useState(false)
  const [loginOpen, setLoginOpen] = useState(false)
  const [createAccountOpen, setCreateAccountOpen] = useState(false)

  const updateGuests = (value) => {
    setSearchParameters(
      {
        ...searchParams,
        guests: value,
      },
      0,
      config.cookieOptions
    )
    let newGuests = 0
    setNumRooms(value.length)
    value.forEach((guests, i) => {
      newGuests += guests.paxes.length
    })
    setNumGuests(newGuests)
  }
  const handleDateChange = (dates) => {
    setSearchParameters(
      {
        ...searchParams,
        checkinDate: moment.isMoment(dates.startDate)
          ? dates.startDate.format('YYYY-MM-DD')
          : dates.startDate,
        checkoutDate: moment.isMoment(dates.endDate)
          ? dates.endDate.format('YYYY-MM-DD')
          : dates.endDate,
      },
      0,
      config.cookieOptions
    )
  }
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'view_item',
      "wt-productName": details.name,
      "wt-productType": 'Retreat',
      "wt-price": details.basePrice,
    })
  }, [details])
  useEffect(() => {
    if (!searchParams.checkinDate && !searchParams.checkoutDate) {
      setSearchParameters(
        {
          ...searchParams,
          checkinDate: moment().format('YYYY-MM-DD'),
          checkoutDate: moment().add(1, 'day').format('YYYY-MM-DD'),
        },
        0,
        config.cookieOptions
      )
    }
  }, [searchParams])

  const updateCheapest = (amount) => {
    setCheapest(amount)
  }

  const searchRetreats = () => {
    const anchor = document.getElementById('accommodation')
    window.scrollTo(
      0,
      anchor.getBoundingClientRect().top +
        document.documentElement.scrollTop -
        120
    )
  }

  useEffect(() => {
    const isMobile = () => {
      setMobile(window.outerWidth <= 767)
    }
    // updateCheapest(details?.fromPrice || 0)
    if (details) {
      let baseRate = details.fromPrice
      let cheapestRate = details.fromPrice
      if (details.hasOwnProperty('rates') && details.rates.length > 0) {
        details.rates.forEach((rate) => {
          if (
            searchParams.checkinDate >= moment(`${rate.startDate} 00:00:00`) &&
            searchParams.checkinDate < moment(`${rate.endDate} 00:00:00`) &&
            baseRate === details.fromPrice
          ) {
            setBaseRate(rate.adults + rate.children)
            if (cheapestRate > rate.adults + rate.children) {
              cheapestRate = rate.adults + rate.children
            }
          }
        })
      }
      setCheapest(cheapestRate)
    }
    if (window) {
      isMobile()
      window.addEventListener('resize', isMobile)
    }
    return () => {
      window.removeEventListener('resize', isMobile)
    }
  }, [details])

  const updateSelectedRoom = (room, remove) => {
    if (room) {
      if (!remove) {
        room.rates.forEach((rate) => {
          if (
            searchParams.checkinDate >= moment(`${rate.startDate} 00:00:00`) &&
            searchParams.checkinDate <= moment(`${rate.endDate} 00:00:00`)
          ) {
            setCheapest(details.fromPrice + rate.adults + rate.children)
          }
        })
        // First we need to check if the room already exists in the array and replace it
        if (selectedRoom.length > 0) {
          const filteredSelected = selectedRoom.filter(
            (r, i) => r.id !== room.id
          )
          if (filteredSelected.length < selectedRoom.length) {
            setSelectedRoom([...filteredSelected, room])
          } else {
            setSelectedRoom([...selectedRoom, room])
          }
        } else {
          setSelectedRoom([...selectedRoom, room])
        }
        setHasSelected(true)
      } else {
        const newRooms = selectedRoom.filter((r) => r.id !== room.id)
        setSelectedRoom(newRooms)
        if (newRooms.length === 0) {
          setCheapest(details.fromPrice)
          setHasSelected(false)
        }
      }
    } else {
      if (remove) {
        setSelectedRoom([])
      }
    }
  }

  const packageEnquiry = async () => {
    await addToCart()
    if (user.email === null) {
      setLoginOpen(true)
    } else {
      setEnquiryPopup(true)
    }
  }
  // useEffect(() => {
  //   console.log(selectedRoom)
  // }, [selectedRoom])

  const loadMessageOverlay = (activity = null) => {
    setModal({
      title: `${details.name}`,
      content: (
        <PreOrder
          packageRoom={selectedRoom}
          contact={details.contact}
          onSend={async () => {
            return await addToCart()
          }}
          checkIn={selectedRoom[0].checkin ?? selectedRoom[0].checkin.format('YYYY-MM-DD')}
          guests={numGuests}
          parent={details}
        />
      ),
    })
  }

  const addToCart = async () => {
    let totalGuests = 0
    for (const r of selectedRoom) {
      totalGuests += r.quantity
    }
    let price = 0
    const roomNames = [];
    for (let i = 0; i < selectedRoom.length; i++) {
      price += selectedRoom[i].perPerson ? selectedRoom[i].price * selectedRoom[i] : selectedRoom[i].price
      roomNames.push(selectedRoom[i].name)
    }
    window.dataLayer.push({
      event: 'add_to_cart',
      "wt-productName": details.name + ' - ' + roomNames.join(', '),
      "wt-productType": 'Retreat',
      "wt-price": price,
    })
    return await addProduct({
      type: 'retreat',
      retreat: details.id,
      packageRoom: selectedRoom.map((r, i) => {
        return {
          id: r.id,
          guests: r.quantity,
          price: r.price,
          checkin: r.checkin.format('YYYY-MM-DD'),
          checkout: r.checkin.add(details.nights, 'days').format('YYYY-MM-DD'),
          name: r.name,
          individual: r.perPerson !== null && r.perPerson ? true : false,
          quantity: r.quantity,
          postOrder: details.enquiryType === 'PostOrder',
        }
      }),
      guests: totalGuests,
      price: {
        net: cheapest,
      },
      // enquiry: 'PreOrder',
    })
  }
  const handleClose = () => {
    setHasSelected(false)
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
  }
  return (
    <React.Fragment>
      <Hero
        background={`${details.featuredImage.url}`}
        isMobile={mobile}
        overlay
        destinations
      >
        <h1>
          {details.pageTitle.smallText}
          <span>{details.pageTitle.largeText}</span>
        </h1>
      </Hero>
      {details.tags && (
        <ul className={classes.tags}>
          {details.tags.map((tag, i) => {
            return <li key={i}>{tag.name}</li>
          })}
        </ul>
      )}
      <div className={classes.introContainer}>
        <Wrapper background={'white'} noMargin>
          <Container maxWidth={'lg'}>
            <Grid container spacing={0} justify={'center'}>
              <Grid item xs={12}>
                <div className={classes.details}>
                  <div
                    onClick={() => {
                      setOpenMap(true)
                    }}
                    style={{ cursor: 'pointer' }}
                    className={classes.map}
                  >
                    {details.hotel && (
                      <>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <div className={classes.detailsContent}>
                          <span>{details.name}</span>
                          <span>Map View</span>
                        </div>
                      </>
                    )}
                  </div>
                  {details.nights && details.nights !== '' && (
                    <div className="mr-4">
                      <span className={classes.number}>{details.nights}</span>
                      <div className={classes.detailsContent}>
                        <span>Nights</span>
                        <span>&nbsp;</span>
                      </div>
                    </div>
                  )}
                  {details.numGuests && details.numGuests !== '' && (
                    <div className="mr-4">
                      <span className={classes.number}>
                        {details.numGuests}
                      </span>
                      <div className={classes.detailsContent}>
                        <span>Guests</span>
                        <span>&nbsp;</span>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container justify={'center'} id="overview">
              <Grid item xs={12}>
                <div className={classes.intro}>
                  <div className={classes.introContent}>
                    <h2 className={`${globalStyles.sectionHeading}`}>
                      Overview
                    </h2>
                    <div
                      dangerouslySetInnerHTML={{ __html: details.overview }}
                    />
                    {details.featuredAmenities &&
                      details.featuredAmenities.amenities.length > 0 && (
                        <>
                          <h2 className={`${globalStyles.sectionHeading} `}>
                            Amenities
                          </h2>
                          <ul className={classes.amenities}>
                            {details.featuredAmenities?.amenities.map(
                              (amenity, i) => {
                                return (
                                  <li key={i}>
                                    {amenity.icon && (
                                      <Image
                                        layout={'fixed'}
                                        width={50}
                                        height={50}
                                        src={amenity.icon.url}
                                        alt={amenity.friendlyName.replace(
                                          'WT ',
                                          ''
                                        )}
                                      />
                                    )}
                                    <span>
                                      {amenity.friendlyName.replace('WT ', '')}
                                    </span>
                                  </li>
                                )
                              }
                            )}
                          </ul>
                        </>
                      )}
                    <Share title={details.name} url={router.asPath} />
                  </div>
                  <TripDates
                    price={formatAmountForDisplay(
                      calculateMarkup(
                        cheapest,
                        settings.baseMarkup,
                        details.markup
                      ),
                      currency,
                      settings.exchangeRate
                    )}
                    onSearch={searchRetreats}
                    buttonLabel={'Date'}
                    hideCalendar
                  />
                </div>
              </Grid>
            </Grid>
          </Container>
        </Wrapper>
      </div>

      {details.gallery.length > 1 && (
        <>
          <Wrapper background={'white'} noMargin>
            <Container maxWidth={'lg'}>
              <Grid container spacing={0} justify={'center'}>
                <Grid item xs={12}>
                  <div className="flex">
                    <h2
                      className={`${globalStyles.sectionHeading} ${globalStyles.withBottomMargin}`}
                    >
                      Gallery
                    </h2>
                  </div>
                </Grid>
              </Grid>
            </Container>
          </Wrapper>
          <DiscoveryGallery gallery={buildGallery(details.gallery)} />
        </>
      )}
      <Wrapper background={'white'} overflowHidden id="availability">
        {details.includes.length > 0 && (
          <Container maxWidth={'lg'}>
            <Grid container spacing={3} justify={'center'}>
              <Grid item xs={12}>
                <div className={globalStyles.indexed}>
                  <h2
                    className={`${globalStyles.sectionHeading} ${globalStyles.large} ${globalStyles.centered}`}
                  >
                    <span className={globalStyles.tag}>The Retreat</span>
                    What&apos;s Included
                  </h2>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.availability}>
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <RetreatFeatures includes={details.includes} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        )}
        {details.packageRooms.length > 0 && (
          <Container maxWidth={'lg'} id="accommodation">
            <Grid container spacing={3} justify={'center'}>
              <Grid item xs={12}>
                <div className={globalStyles.indexed}>
                  <h2
                    className={`${globalStyles.sectionHeading} ${globalStyles.large} ${globalStyles.centered}`}
                  >
                    <span className={globalStyles.tag}>
                      {details.offersAdventure
                        ? details.offersAdventure
                        : 'The Adventure'}
                    </span>
                    {details.offersHeading
                      ? details.offersHeading
                      : 'Accommodation'}
                  </h2>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.availability}>
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <RetreatRooms
                      rooms={details.packageRooms}
                      fromPrice={details.fromPrice}
                      updateCheapest={updateCheapest}
                      fromDate={searchParams.checkinDate}
                      selectedRoom={selectedRoom}
                      updateSelectedRoom={updateSelectedRoom}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        )}
        <Container maxWidth={'lg'}>
          <Grid container spacing={3} justify={'center'}>
            <Grid item xs={12}>
              <div className={`${classes.availability} `}>
                <div
                  style={{
                    textAlign: 'center',
                    background:
                      'linear-gradient(180deg, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%)',
                    paddingBottom: '10px',
                  }}
                  className={'mt-8'}
                >
                  <button
                    className={`${classes.enquire} cta-event-trigger`}
                    disabled={selectedRoom.length === 0}
                    onClick={() => {
                      if (selectedRoom.length > 0) {
                        // if (user.email !== null) {
                          loadMessageOverlay(selectedRoom)
                        // } else {
                        //   setModal({
                        //     title: 'Welcome back!',
                        //     content: (
                        //       <LoginPopup
                        //         onClose={() => {
                        //           loadMessageOverlay(selectedRoom)
                        //         }}
                        //         noRedirect
                        //       />
                        //     ),
                        //   })
                        // }
                      }
                    }}
                  >
                    Enquire Now
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>

      <div className={classes.orderContainer}>
        <div
          className={`bookingHover ${classes.booking} ${classes.bookingOverview}`}
        ></div>
        <div className={classes.stickyContainer}>
          <div className={classes.accordionWrapper}>
            <Wrapper
              background={'offWhite'}
              noMargin
              id="additional-information"
            >
              <Container maxWidth={'lg'}>
                <div className={classes.watermark}>
                  <Watermark />
                </div>
                <Grid container justify={'center'}>
                  <Grid item xs={12}>
                    <div className={classes.overview}>
                      <div className={classes.introContent}>
                        <a className="anchor" />
                        <h2 className={`${globalStyles.sectionHeading}`}>
                          Additional Information
                        </h2>
                        <div className={classes.accordion}>
                          <Accordion>
                            {details.additionalInformation.map((info, i) => {
                              return (
                                <AccordionItem key={i}>
                                  <AccordionItemHeading>
                                    <AccordionItemButton className="info-accordion-button">
                                      {info.heading}
                                      <FontAwesomeIcon icon={faChevronDown} />
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: info.content,
                                      }}
                                    />
                                  </AccordionItemPanel>
                                </AccordionItem>
                              )
                            })}
                          </Accordion>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Container>
            </Wrapper>
          </div>
        </div>
      </div>
      <Wrapper background={'white'} withPadding>
        <Container maxWidth={'lg'}>
          <Grid container spacing={3} justify={'center'}>
            <Grid item xs={12} md={9}>
              <Newsletter />
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
      {loginOpen && (
        <LoginPopup
          onClose={() => {
            setLoginOpen(false)
            setEnquiryPopup(true)
          }}
          onCreateAccount={() => setCreateAccountOpen(true)}
          noRedirect
        />
      )}
      {createAccountOpen && (
        <CreateAccountPopup
          onClose={() => {
            setCreateAccountOpen(false)
            setEnquiryPopup(true)
          }}
          onLogin={() => setLoginOpen(true)}
          noRedirect
        />
      )}
      {enquiryPopup && user.email !== null && (
        <Overlay
          onClose={() => {
            setEnquiryPopup(false)
          }}
          header={`Messaging - ${details.name}`}
          hideClose
        >
          <MessageOverlay
            user={user}
            retreatDetails={details}
            room={selectedRoom}
            contact={details.contact}
            onSend={() => {
              setEnquiryPopup(false)
            }}
            checkIn={searchParams.checkinDate.format('YYYY-MM-DD')}
            guests={numGuests}
          />
        </Overlay>
      )}
      {openMap && (
        <MapOverlay
          location={details.location}
          title={details.name}
          onClose={() => setOpenMap(false)}
        />
      )}
      <Snackbar
        open={hasSelected}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          Scroll down to enquire about the selected retreat.
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}
RetreatDetails.propType = {
  slug: PropTypes.string,
  details: PropTypes.object.isRequired,
}
export default RetreatDetails
